import { render, staticRenderFns } from "./YtTrendsTab.vue?vue&type=template&id=0412eb06&scoped=true&"
import script from "./YtTrendsTab.vue?vue&type=script&lang=js&"
export * from "./YtTrendsTab.vue?vue&type=script&lang=js&"
import style0 from "./YtTrendsTab.vue?vue&type=style&index=0&id=0412eb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412eb06",
  null
  
)

export default component.exports